import { monthViewOverFlowMoreEventsInAgenda } from './getOverflowIndicatorAriaLabel.locstring.json';
import loc, { format } from 'owa-localize';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

import { formatWeekDayMonthDayYear } from 'owa-datetime';

export default function getOverflowIndicatorAriaLabel(item: CalendarEvent) {
    return format(loc(monthViewOverFlowMoreEventsInAgenda), formatWeekDayMonthDayYear(item.Start));
}
